<template>
    <div class="update-card-modal">
        <div
            class="modal-close"
            @click="closeUpdateModal"
        >
            <i class="far fa-times" />
        </div>
        <p class="modal-title">
            Update Payment Method
        </p>
        <card-form
            :skip-registration="true"
            :update="true"
        />
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import modal from '@/mixins/modal';
import CardForm from '@/components/Register/CardForm.vue';

export default {
    components: {
        CardForm,
    },

    mixins: [modal],

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Closes upgrade modal
         */
        closeUpdateModal() {
            this.changeUIState({ isUpdateModalVisible: false });
        },
    },
};
</script>
